import { Alert } from '@ps/isp-web-component-library';
import React from 'react';
import { useSelector } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { select } from '@swf/core/store';

import useTotals from '../../../../hooks/useTotals';
import { getIsDailyMaxPayoutLimitReached } from '../../../../utils/isDailyMaxPayoutLimitReached';

import {
  TXTWCL_Maximum_Payout_Exceeded,
  TXTWCL_Our_maximum_daily_payout_is_N0_ELL_1
} from './MaxPayout.messages.json';

const MaxPayout: React.FC = () => {
  const { formatMessage } = useRegulatoryIntl();
  const dailyMaxPayoutLimit = useSelector(select.betSlip.dailyMaxPayoutLimit);
  const { totalPotentialReturns } = useTotals();

  const isDailyMaxPayoutLimitReached = getIsDailyMaxPayoutLimitReached(
    dailyMaxPayoutLimit,
    totalPotentialReturns
  );

  if (!isDailyMaxPayoutLimitReached) {
    return null;
  }

  return (
    <Alert
      as="li"
      title={formatMessage(TXTWCL_Maximum_Payout_Exceeded)}
      level="destructive"
      variant="aggressive"
      isSquare
    >
      {formatMessage(TXTWCL_Our_maximum_daily_payout_is_N0_ELL_1, {
        0: <CurrencyAmount value={dailyMaxPayoutLimit} dollarValue />
      })}
    </Alert>
  );
};

export default MaxPayout;
